<template>
  <div class="newspaper">
    <div v-title :data-title="title"></div>
    <div class="main">
      <pullDownRefresh @upPull="myUpPull()" :loader="upPullLoader">
      </pullDownRefresh>
      <div class="newspaper_img">
        <sliderModule @slideChange="slideChange" :activeIndex.sync="activeIndex" :mySwiper.sync="mySwiper"
          :updateData.sync="allPageList" :options="swiperOptions" v-if="newsPaperModules && newsPaperModules.length > 0"
          :modules="newsPaperModules">
        </sliderModule>
      </div>
      <transition name="fade">
        <div class="banmian" v-if="showBanMian">
          <newspaperLayout :pageList="banMianArr" :showLayout="showBanMian" @getNewspaperDetail="getNewspaperDetail"
            @close="showBanMianFn"></newspaperLayout>
        </div>
      </transition>
      <div class="catalogue_area" v-if="showCatalogue">
        <ArticleDirections :categoryArr="articleList" @close="showCatalogueFn"></ArticleDirections>
      </div>
    </div>
    <div class="footer">
      <div class="layout" @click="showBanMianFn">
        <i class="icon">
          <img src="../../../../public/image/banmian.png" />
        </i>
        <span v-text="banMianIndex"></span>
      </div>
      <div class="catalogue" @click="showCatalogueFn">
        <i class="icon">
          <img src="../../../../public/image/articleList.png" />
        </i>
        <span>列表</span>
      </div>
      <div class="date" @click="showCalendarFn">
        <datePicker @callback="selectDate()" :selectedDate.sync="selectedTime" :disabled="disabledFn"
          @changedMonth="changedMonth">
          <div class="btn">
            <i class="icon">
              <img src="../../../../public/image/wangqi.png" />
            </i>
            <span>往期</span>
          </div>
        </datePicker>
      </div>
    </div>
  </div>
</template>
<script>
import newspaperLayout from "./components/newspaperLayout.vue";
import datePicker from "./components/datePicker.vue";
import ArticleDirections from "./components/ArticleDirections.vue";
import pullDownRefresh from "../../../components/pullDownRefresh/pullDownRefresh.vue";
import sliderModule from "../../../components/sliderModule.vue";
export default {
  name: "newspaperOfMobile",
  components: {
    newspaperLayout,
    ArticleDirections,
    pullDownRefresh,
    sliderModule,
    datePicker,
  },
  data() {
    return {
      showBanMian: false,
      selectedBanMian: "",
      allPageList: [], //版面集合
      banMianArr: [],
      curNewspaperPage: "", //当前版
      imgsAddress: "", //图片访问前缀
      articleList: [], // 文章列表
      showCatalogue: false,
      showCalendar: false, //展示日期控件
      newsPaperModules: "",
      selectedTime: this.$route.query.publishTime, //报纸发布时间,
      BanMianNumber: 1,
      activeIndex: 0,
      upPullLoader: "",
      noData: [
        {
          DOCTITLE: "暂无相关目录信息",
        },
      ],
      mySwiper: "",
      swiperOptions: {
        direction: "vertical",
      },
      route: this.$route,
      title: "",
      hasDataDates: [],
    };
  },
  async mounted() {
    this.getMediaLogoAndSignature();
    await this.requestData();
    const curEditionIndex = (this.curEditionIndex >= this.allPageList.length - 1) ? 0 : this.curEditionIndex
    this.mySwiper.slideTo(curEditionIndex);
  },
  methods: {
    /**
     * @description: 版面滑动事件
     * @return {*}
     */
    slideChange(activeIndex) {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.$route.query,
          curEdition: activeIndex + 1
        }
      });
    },
    /*展示版面*/
    showBanMianFn() {
      if (this.showBanMian == true) {
        this.showBanMian = false;
      } else {
        this.showBanMian = true;
      }
      this.showCatalogue = false;
    },
    /*展示目录信息*/
    showCatalogueFn() {
      if (this.showCatalogue == true) {
        this.showCatalogue = false;
      } else {
        this.showCatalogue = true;
      }
      this.showBanMian = false;
    },
    //展开时间控件
    showCalendarFn() {
      this.showBanMian = false;
      this.showCatalogue = false;
      this.showCalendar = !this.showCalendar;
    },
    /**
     * [getFirstNewspaperPageList description]获取首版
     * @return {[type]} [description]
     */
    getFirstNewspaperPageList() {
      return new Promise((resolve, reject) => {
        let self = this;
        let params = {
          digitalNewspaperMark: self.route.query.mediaKey,
        };
        self
          .post(
            "/digitalNewspaper/web/layoutCatalog/listByDigitalNewspaperMark",
            params
          )
          .then(
            (resp) => {
              try {
                self.allPageList = resp.msg;
                self.banMianArr = resp.msg;
                self.curNewspaperPage = resp.msg[0];
                self.imgsAddress = resp.addressPrefix;
                self.selectedTime = self.formatDate(
                  self.curNewspaperPage.publishTime,
                  "yyyy-MM-dd"
                );
                this.getNewspaperModules();
                this.getHasDataDates(self.selectedTime);
                resolve();
              } catch (e) {
                console.error(e);
                reject();
              }
            },
            (reject) => {
              this.$router.push({
                path: "/homePage",
              });
            }
          );
      });
    },
    /**
     * [getMediaLogoAndSignature description]获取网站签名和logo
     * @return {[type]} [description]
     */
    getMediaLogoAndSignature() {
      let self = this;
      let params = {
        digitalNewspaperMark: self.route.query.mediaKey,
      };
      self
        .post(
          "/digitalNewspaper/web/digitalNewspaperMedia/findByDigitalNewspaperMark",
          params
        )
        .then((resp) => {
          try {
            self.title = resp.digitalNewspaperName;
          } catch (e) {
            console.log(e);
          }
        });
    },
    /**
     * [getNewspaperPageListByTimeAndMedia description]根据发布时间和媒体标识查询数字报
     * @return {[type]} [description]
     */
    getNewspaperPageListByTimeAndMedia() {
      return new Promise((resolve, reject) => {
        var self = this;
        let params = {
          digitalNewspaperMark: self.route.query.mediaKey,
          publishTime: self.selectedTime,
        };
        self
          .post(
            "/digitalNewspaper/web/layoutCatalog/listByDigitalNewspaperMarkAndPublishTime",
            params
          )
          .then(
            (resp) => {
              try {
                self.allPageList = resp.msg;
                self.banMianArr = resp.msg;
                self.curNewspaperPage = resp.msg[0];
                self.imgsAddress = resp.addressPrefix;
                this.getNewspaperModules();
                resolve(self.curNewspaperPage);
              } catch (e) { }
            },
            (reject) => {
              self.$ask({
                type: "error",
                showCancel: false,
                content: reject.msg,
                time: 1000,
              });
            }
          );
      });
    },
    /**
     * [getNewspaperPageDetail description]获取版面坐標及文章列表
     * @param  {[type]} curPage [description]当前版面
     * @return {[type]}         [description]
     */
    getNewspaperPageDetail(curPage) {
      return new Promise((resolve, reject) => {
        let self = this;
        let params = {
          layoutCatalogId: curPage.layoutCatalogId,
        };
        self
          .post(
            "/digitalNewspaper/web/layoutDetail/listByLayoutCatalogId",
            params
          )
          .then((resp) => {
            try {
              self.articleList = resp.msg;
              resolve(resp.msg);
            } catch (e) {
              console.log(e);
            }
          });
      });
    },
    /**
     * [requestData description] 获取数据
     * @return {[type]} [description]
     */
    async requestData() {
      const self = this;
      self.allPageList = [];
      self.newsPaperModules = "";
      if (self.selectedTime) {
        self.getHasDataDates(self.selectedTime);
        await self.getNewspaperPageListByTimeAndMedia();
      } else {
        await self.getFirstNewspaperPageList();
      }
      /* return new Promise((resolve, reject) => {
        this.getFirstNewspaperPageList().then(
          () => {
            resolve();
          },
          () => {
            reject();
          }
        );
      }); */
    },
    /**
     * [getNewspaperModules description] 获取版面视图的模块集合
     * @return {[type]} [description]
     */
    getNewspaperModules() {
      let self = this;
      let arr = self.allPageList;
      let modules = arr.map((item) => {
        return {
          moduleFn: () => import("./components/newspapersDigitalEdition.vue"),
          props: {
            areaMapList: this.articleList,
            imgSrc: self.imgsAddress + item.jpgPath,
          },
          beforeLoadModule() {
            let self_ = this;
            return new Promise((resolve, reject) => {
              self.getNewspaperPageDetail(item).then((resp) => {
                self_.props.areaMapList = resp;
                resolve(self_.props.areaMapList);
              });
            });
          },
        };
      });
      this.newsPaperModules = modules;
    },
    //刷新版面
    getNewspaperDetail(data) {
      let index = this.banMianArr.findIndex((item) => {
        return item.layoutCatalogId == data.layoutCatalogId;
      });
      this.mySwiper.slideTo(index);
      this.showBanMian = false;
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.$route.query,
          curEdition: index + 1
        }
      });
    },
    //点击时间控件选择日期
    selectDate() {
      this.allPageList = [];
      this.newsPaperModules = "";
      let curTime = this.selectedTime;
      this.selectedTime = curTime;
      this.getNewspaperPageListByTimeAndMedia().then((data) => {
        this.getNewspaperPageDetail(data);
      });
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.$route.query,
          publishTime: this.selectedTime
        }
      });
    },
    changedMonth(date) {
      this.getHasDataDates(date);
    },
    /**
     * @[getHasDataDates description] 获取当前月有数据的日期
     * @param {*} date
     * @return {*} [desc] 返回前后30天有数据的日期
     */
    getHasDataDates(date) {
      let date_ = this.formatDate(date, "yyyy-MM-dd") + " 00:00:00";
      return new Promise((resolve) => {
        this.post("/digitalNewspaper/web/layout/findHasDataDate", {
          digitalNewspaperMediaId: this.$route.query.id,
          currentTime: date_,
        }).then((res) => {
          this.hasDataDates = [...new Set([...this.hasDataDates, ...res.msg])];
          resolve();
        });
      });
    },
    //下拉刷新函数
    myUpPull() {
      this.upPullLoader = this.requestData();
    },
  },
  computed: {
    /**
     * @description: 当前版面
     * @return {*}
     */
    curEditionIndex() {
      return isNaN(this.$route.query.curEdition) ? 0 : Number(this.$route.query.curEdition) - 1;
    },
    //禁止选择的时间
    disabledFn() {
      return (disAbleddate) => {
        let today = this.formatDate(new Date(), "yyyy-MM-dd");
        let maxDate = new Date(today); //大于当天日期的日期不能选
        let minDate = new Date();
        minDate.setDate(minDate.getDate() - 180);
        let date = this.formatDate(disAbleddate, "yyyy-MM-dd") + " 00:00:00";
        return (
          disAbleddate > maxDate ||
          disAbleddate < minDate ||
          !this.hasDataDates.includes(date)
        );
      };
    },
    /**
     * [goToReadNewspapersDetail description]跳转至详情页
     * @return {[type]} [description]
     */
    goToReadNewspapersDetail() {
      let router = this.$router.resolve({
        name: "readNewspapersDeatil",
      });
      return router.href;
    },
    /**
     * [banMianIndex description] 版面序号
     * @return {[type]} [description]
     */
    banMianIndex() {
      if (!this.mySwiper) return;
      let result;
      try {
        let index = this.banMianArr[this.mySwiper.activeIndex].edition;
        result = `第${index}版`;
      } catch (e) {
        console.log(e);
      }
      return result;
    },
  },
};
</script>
<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.newspaper {
  width: 100%;
  height: 100%;
  position: relative;

  .main {
    width: 100%;
    height: calc(100% - 80px);
    border-top: solid 0.01rem rgba(232, 232, 232, 1);
    position: relative;
    overflow: auto;
    box-sizing: border-box;

    &::-webkit-scrollbar {
      display: none;
    }

    .newspaper_img {
      width: 100%;
      height: 100%;

      .no_data {
        text-align: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: inline-block;
        line-height: 0.3rem;
      }
    }

    .banmian {
      width: 100%;
      height: calc(100% - 0.19rem);
      position: absolute;
      bottom: 0;
      z-index: 99;
      left: 0;
    }

    .catalogue_area {
      width: 100%;
      height: 100%;
      top: 0;
      position: absolute;
      z-index: 99;
    }
  }

  .footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    height: 80px;
    padding-left: 25px;
    padding-right: 25px;
    z-index: 99;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    line-height: 80px;

    div {
      display: flex;
      align-items: center;
      height: 100%;

      .icon {
        display: inline-block;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        position: relative;
        margin-right: 5px;

        img {
          width: 12px;
          height: 12px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      span {
        font-size: 16px;
        font-weight: normal;
        color: #000;
        display: inline-block;
        vertical-align: top;
      }
    }

    .layout {
      .icon {
        background: #55a8fd;
      }
    }

    .catalogue {
      .icon {
        background: #ff824f;
      }
    }

    .date {
      /deep/.date_picker {
        .trigger {
          width: 100%;
          height: 100%;
          display: inline-block;

          .btn {
            display: flex !important;
            padding: 0 !important;
            margin: 0 !important;
            height: 100% !important;
            border: none !important;
            background: rgba(0, 0, 0, 0) !important;
            outline: none !important;
            align-items: center;

            .icon {
              background: #31cabf;
            }
          }
        }
      }
    }
  }
}

@media screen and(min-width:768px) {
  .newspaper {
    /*  .main {
           width: 70%;
           margin: 0 auto;
       } */

    .footer {
      padding-left: 15%;
      padding-right: 15%;
    }
  }
}
</style>